module.exports = __webpack_public_path__ + "img/logo_econect.8e0542c7.png";